import { EventEmitter, Injectable } from '@angular/core';
import { CustomProductSettingsRequest } from 'apps/shared/src/models';
import { CustomProductCalculations } from '@msslib/models/custom-product-calculations';
import { Observable, tap } from 'rxjs';
import { ClubHubDataService } from './clubhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class UserCustomProductSettingsService {
  /** Fired when the user updates their custom product settings. */
  public readonly settingsChange = new EventEmitter<void>();

  public constructor(
    private readonly clubHubDataService: ClubHubDataService,
  ) {}

  public getUserCustomProductSettings(): Observable<CustomProductCalculations> {
    return this.clubHubDataService.get<CustomProductCalculations>('CustomProductSettings/Users');
  }

  public updateUserCustomProductSettings(request: CustomProductSettingsRequest): Observable<void> {
    return this.clubHubDataService.post<never>('CustomProductSettings/Users', request)
      .pipe(tap(() => this.settingsChange.emit()));
  }
}
